<wb-card [variant]="dark ? 'dark-grey' : 'light-grey'">
  <address>
    <div class="personal-info">
      <div class="personal-info-text">
        <wb-heading size="s">{{ fullname }}</wb-heading>
        <wb-text size="l"><span [innerHTML]="positionHTML"></span></wb-text>
      </div>
      <div class="rounded-image">
        @if (image) {
          <mb-image [media]="image" (imageError)="image = undefined"></mb-image>
        }
        @if (!image) {
          <div class="name-initials">
            {{ initials }}
          </div>
        }
      </div>
    </div>
    @if (email || phone) {
      <div class="contact-info">
        @if (email) {
          <div>
            <wb-text size="s">{{ 'EMAIL' | translate }}:</wb-text>
            <wb-text size="l">
              <wb-link [theme]="dark ? 'dark' : 'light'" href="mailto:{{ email }}" variant="standalone"
                >{{ emailFirstPart }}<wbr />{{ emailSecondPart }}</wb-link
              >
            </wb-text>
          </div>
        }
        @if (phone) {
          <div>
            <wb-text size="s">{{ 'PHONE' | translate }}:</wb-text>
            <wb-text size="l">
              <wb-link [theme]="dark ? 'dark' : 'light'" href="tel:{{ phone }}" variant="standalone">{{
                phone
              }}</wb-link>
            </wb-text>
          </div>
        }
        @if (linkedIn) {
          <div class="social-address">
            <wb-text size="s">{{ 'LinkedIn' | translate }}:</wb-text>
            <wb-text size="l">
              <wb-link
                target="_blank"
                [theme]="dark ? 'dark' : 'light'"
                href="https:///www.linkedin.com/in/{{ linkedIn }}"
                variant="standalone"
              >
                linkedin.com/in/{{ linkedIn }}
              </wb-link>
            </wb-text>
          </div>
        }
        @if (x) {
          <div class="social-address">
            <wb-text size="s">{{ 'X' | translate }}:</wb-text>
            <wb-text size="l">
              <wb-link
                target="_blank"
                [theme]="dark ? 'dark' : 'light'"
                href="https://x.com/{{ x }}"
                variant="standalone"
                >{{ '@' + x }}</wb-link
              >
            </wb-text>
          </div>
        }
      </div>
    }
  </address>
</wb-card>
